<template>
	<div class="monitor">
		<div class="title">
			<img src="../../../assets/img/logo.png" alt="">
			<span>视频监控</span>
		</div>
		<div class="monitor_box">
			<div ><video src="../../../assets/video/WeChat_20211012163527.mp4"    autoplay="autoplay" loop="loop" muted></video><p>设备编号:001</p></div>
			<div><video  src="../../../assets/video/WeChat_20211012163544.mp4" autoplay="autoplay" loop="loop"  muted></video><p>设备编号:002</p></div>
			<div><video src="../../../assets/video/WeChat_20211012163919.mp4" autoplay="autoplay" loop="loop"  muted></video><p>设备编号:003</p></div>
			<div><video src="../../../assets/video/WeChat_20211012163929.mp4" autoplay="autoplay" loop="loop"  muted></video><p>设备编号:004</p></div>
		</div>
	</div>
</template>

<script>
	import flvjs from 'flv.js'
	export default {
	  name: "",
	  data() {
	  	return{
			// date:[
			// 	{
			// 	flvPlayer:null,
			// 	url:'http://47.119.135.239:1010/live/185.flv'
			// 	},
			// 	{
			// 	flvPlayer:null,
			// 	url:'http://47.119.135.239:1010/live/186.flv'
			// 	},
			// 	{
			// 	flvPlayer:null,
			// 	url:'http://47.119.135.239:1010/live/187.flv'
			// 	},
			// 	{
			// 	flvPlayer:null,
			// 	url:'http://47.119.135.239:1010/live/184.flv'
			// 	}
			// 	]
		}
	  },
	  computed: {
	  },
	  methods: {
	  },
	  created() {
	  	
	  },
	  mounted() {
		   // if (flvjs.isSupported()) {
			  //    this.date.forEach((item,index)=>{
					//  var videoElement = document.getElementById('videoElement'+index);
					//    this.flvPlayer = flvjs.createPlayer({
					//     type: 'flv',
					//     isLive: true,
					//     hasAudio: false,
					//     url: item.url
					//    });
					//    this.flvPlayer.attachMediaElement(videoElement);
					//    this.flvPlayer.load();
					//    this.flvPlayer.play();
				 // })
		         
		   //      }
	  }
	};
</script>

<style scoped="scoped">
	.monitor{
		width: 100%;
		height: 38%;
	}
	.monitor_box{
		width: 100%;
		height: calc(100% - 4vh);
		box-sizing: border-box;
		padding: 1vh 0;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
	.monitor_box>div{
		position: relative;
		background: url(../../../assets/img/appbg.png) no-repeat center/100% 100%;
		width: 48%;
		height: 48%;
	}
	.monitor_box>div>video{
		width: 100%;
		height: 100%;
		 object-fit: fill;
	}
	.monitor_box>div>p{
		position: absolute;
		color: #FFFFFF;
		top: 0;
		z-index: 1;
		box-sizing: border-box;
		padding: 2% 0 0 2%;
		font-size: 0.5vw;
	}
</style>
